import type { Account } from './useAccounts'

/**
 * "Chequing ••4821", or just the name for an account with no mask. The accounts
 * module's own export, so another module (M7's recurring rows) can label an
 * account without importing from a sibling route. Behaviour is identical to
 * `transactions/txnDisplay.ts`'s `accountLabel`.
 */
export function accountLabel(a: Pick<Account, 'name' | 'mask'>): string {
  return a.mask ? `${a.name} ••${a.mask}` : a.name
}
